var WEEKDAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"];

function isSameDay(d1, d2) {
  return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
}
function dateToStr(d) { return d.toISOString().split("T")[0]; }

export default function MiniCalendar({ currentDate, schedules, roomBookings, events, onDateSelect, selectedDate }) {
  var year = currentDate.getFullYear();
  var month = currentDate.getMonth();
  var firstDay = new Date(year, month, 1).getDay();
  var daysInMonth = new Date(year, month + 1, 0).getDate();
  var today = new Date();
  var cells = [];
  for (var i = 0; i < firstDay; i++) cells.push(<div key={"e-" + i} className="h-9" />);
  for (var d = 1; d <= daysInMonth; d++) {
    var cellDate = new Date(year, month, d);
    var isToday = isSameDay(cellDate, today);
    var isSelected = selectedDate && isSameDay(cellDate, selectedDate);
    var cellStr = dateToStr(cellDate);
    var hasSch = false, hasRm = false, hasEv = false;
    for (var s = 0; s < schedules.length; s++) { try { if (isSameDay(new Date(schedules[s].date), cellDate)) { hasSch = true; break; } } catch (e) {} }
    for (var r = 0; r < roomBookings.length; r++) { if (roomBookings[r].date === cellStr) { hasRm = true; break; } }
    for (var ev = 0; ev < events.length; ev++) { if (events[ev].start_date <= cellStr && (events[ev].end_date || events[ev].start_date) >= cellStr) { hasEv = true; break; } }
    var cls = "h-9 w-9 rounded-lg text-sm flex items-center justify-center cursor-pointer transition-all relative ";
    if (isSelected) cls += "bg-[#3B82F6] text-white font-semibold";
    else if (isToday) cls += "bg-[#F26A4B]/10 text-[#F26A4B] font-semibold";
    else cls += "hover:bg-gray-100 text-gray-700";
    cells.push(
      <div key={d} className={cls} onClick={(function(day){return function(){onDateSelect(new Date(year,month,day));};})(d)} data-testid={"cal-day-"+d}>
        {d}
        <div className="absolute bottom-0.5 left-1/2 -translate-x-1/2 flex gap-0.5">
          {hasSch && <span className="w-1 h-1 rounded-full bg-[#3B82F6]" />}
          {hasRm && <span className="w-1 h-1 rounded-full bg-amber-500" />}
          {hasEv && <span className="w-1 h-1 rounded-full bg-violet-500" />}
        </div>
      </div>
    );
  }
  var hdr = WEEKDAYS.map(function(w,i){return <div key={i} className="h-8 flex items-center justify-center text-xs font-medium text-gray-400">{w}</div>;});
  return (<div data-testid="mini-calendar"><div className="grid grid-cols-7 gap-0.5">{hdr}{cells}</div></div>);
}
